import React from "react";
import { PrimaryButton, SecondaryButton } from "../../StyledCss/styledbtn";

/*
 * Roles this role may hand out on the Add/Edit Employee screens, as a dropdown
 * anchored to the permission row it belongs to.
 *
 * Not a permission itself — nothing here grants access. It narrows the role
 * dropdown the holder of THIS role sees. At least one role is required: the
 * caller refuses an empty selection, and when the dropdown was opened by
 * switching the permission on, that permission is only enabled once OK
 * succeeds. OK stages the choice; it is written on Save Changes.
 */
const AssignableRolesDropdown = ({
  panelRef,
  style,
  roles,
  selectedRoleIds,
  onToggleRole,
  onCancel,
  onConfirm,
}) => (
  <div
    className="rpe-assignable-dropdown"
    ref={panelRef}
    style={style}
    role="dialog"
    aria-label="Roles this role can assign"
  >
    <p className="rpe-assignable-dropdown-title">Roles this role can assign</p>
    <p className="rpe-assignable-dropdown-hint">
      Only these appear in the role dropdown when someone with this role adds or
      edits an employee. Pick at least one.
    </p>

    {roles.length === 0 ? (
      <p className="rpe-assignable-dropdown-hint">No roles available to assign.</p>
    ) : (
      <div className="rpe-assignable-dropdown-list">
        {roles.map((role) => {
          const inputId = `assignable-role-${role.id}`;
          return (
            <label className="rpe-assignable-role" key={role.id} htmlFor={inputId}>
              <input
                id={inputId}
                type="checkbox"
                checked={selectedRoleIds.includes(role.id)}
                onChange={() => onToggleRole(role.id)}
              />
              <span>{role.name}</span>
            </label>
          );
        })}
      </div>
    )}

    <div className="rpe-assignable-dropdown-actions">
      <span className="rpe-assignable-dropdown-count">
        {selectedRoleIds.length} of {roles.length} selected
      </span>
      <div className="rpe-assignable-dropdown-buttons">
        <SecondaryButton type="button" onClick={onCancel}>
          Cancel
        </SecondaryButton>
        <PrimaryButton type="button" width="80px" onClick={onConfirm}>
          OK
        </PrimaryButton>
      </div>
    </div>
  </div>
);

export default AssignableRolesDropdown;
